import { gql } from '@apollo/client';

export const GET_HISTORICAL_OVERRIDE_HISTORY = gql`
    query GetHistoricalOverrideHistory($input: GetImportLogsInput!) {
        getManualImportLogs(input: $input) {
            total
            logs {
                id
                fileName
                status
                createdAt
                scheduledFor
                startedAt
                completedAt
                recordsProcessed
                error
                cancelledAt
                createdBy {
                    id
                    firstName
                    lastName
                }
                cancelledBy {
                    id
                    firstName
                    lastName
                }
            }
        }
    }
`;
